import { render, staticRenderFns } from "./demo-selector.vue?vue&type=template&id=633477ba&scoped=true&"
import script from "./demo-selector.vue?vue&type=script&lang=js&"
export * from "./demo-selector.vue?vue&type=script&lang=js&"
import style0 from "./demo-selector.vue?vue&type=style&index=0&id=633477ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633477ba",
  null
  
)

export default component.exports